<!-- 短视频 -->
<template>
  <div class="warp">
    <div class="banner">
      <p>短视频系统</p>
      <span>
        多元的“短视频+”解决方案
        <br />抖音、小红书，你想要的玩法都在这里
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="item1">
      <div class="title">短视频 闪电记录多彩生活</div>
      <ul>
        <li>
          <img src="../../assets/images/video01.png" />
          <span>在线录制</span>
        </li>
        <li>
          <img src="../../assets/images/video02.png" />
          <span>本地上传</span>
        </li>
        <li>
          <img src="../../assets/images/video03.png" />
          <span>特效美颜</span>
        </li>
        <li>
          <img src="../../assets/images/video04.png" />
          <span>海量配乐</span>
        </li>
        <li>
          <img src="../../assets/images/video05.png" />
          <span>转发分享</span>
        </li>
        <li>
          <img src="../../assets/images/video06.png" />
          <span>热门推荐</span>
        </li>
        <li>
          <img src="../../assets/images/video07.png" />
          <span>点赞评论</span>
        </li>
        <li>
          <img src="../../assets/images/video08.png" />
          <span>视频广告</span>
        </li>
      </ul>
    </div>
    <div class="item2">
      <div class="title">“短视频+”解决方案 应用场景更广阔</div>
      <div class="box box1">
        <div class="img">
          <img src="../../assets/images/page62.png" />
        </div>
        <div class="subTitle">短视频+直播广场</div>
        <ul>
            <li>
                <img src="../../assets/images/video09.png">
                <div>
                    <span>首页推荐,汇聚海量热门视频</span>
                    <p>首页推荐优质直播内容，持续提高热度</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video10.png">
                <div>
                    <span>关注主播，个人动态实时更新</span>
                    <p>实时更新主播动态，及时了解主播最新动向</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video11.png">
                <div>
                    <span>礼物打赏，直播互动更多元</span>
                    <p>直播间支持进行礼物打赏，礼物类型多样</p>
                </div>
            </li>
        </ul>
      </div>

      <div class="box">
        <div class="img">
          <img src="../../assets/images/page65.jpg" />
        </div>
        <div class="subTitle">短视频+1对1直播</div>
        <ul>
            <li>
                <img src="../../assets/images/video12.png">
                <div>
                    <span>1对1直播，精准对标直播需求</span>
                    <p>精准直播，满足用户私密性和个性化需求</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video13.png">
                <div>
                    <span>付费直播，按时计费</span>
                    <p>按分钟计时付费收看直播，赚取更多收益</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video14.png">
                <div>
                    <span>短视频预告，直播内容抢先看</span>
                    <p>主播先上传短视频，用户观看视频后再发出直播请求</p>
                </div>
            </li>
        </ul>
      </div>


       <div class="box">
        <div class="img" style="margin-top:-.3rem;">
          <img src="../../assets/images/page66.jpg" />
        </div>
        <div class="subTitle">短视频+电商</div>
        <ul>
            <li>
                <img src="../../assets/images/video15.png">
                <div>
                    <span>视频动态展示，商品细节更全面</span>
                    <p>利用短视频分享商品细节，激励用户购买</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video16.png">
                <div>
                    <span>数据引导，商品推荐更智能</span>
                    <p>根据用户数据智能推荐商品，提高转化率</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video17.png">
                <div>
                    <span>边看边买，随心购物更自在</span>
                    <p>边看视频边购物，一键添加商品至购物车</p>
                </div>
            </li>
        </ul>
      </div>



      <div class="box">
        <div class="img">
          <img src="../../assets/images/page67.jpg" />
        </div>
        <div class="subTitle" style="margin-top:-2rem;">短视频+营销</div>
        <ul>
            <li>
                <img src="../../assets/images/video18.png">
                <div>
                    <span>视频观看奖励，激发观看热情</span>
                    <p>设置视频观看奖励，红包，礼物多种奖励方式</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video19.png">
                <div>
                    <span>打卡任务，提高用户活跃度</span>
                    <p>设置打卡奖励，奖励机制、打卡形式多样</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video20.png">
                <div>
                    <span>视频广告，增加推广形式</span>
                    <p>可嵌开屏广告、信息流广告、推广形式更丰富</p>
                </div>
            </li>
        </ul>
      </div>


      <!-- <div class="box">
        <div class="img" style="margin-top:-2.5rem;">
          <img src="../../assets/images/page68.jpg" />
        </div>
        <div class="subTitle">短视频+分销</div>
        <ul>
            <li>
                <img src="../../assets/images/video21.png">
                <div>
                    <span>多级分销机制，轻松占领市场</span>
                    <p>借助社交网络分销产品，实现裂变式分销</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video22.png">
                <div>
                    <span>返佣方式多样，自由可选</span>
                    <p>多种返佣方式，商品佣金、等级佣金自定义</p>
                </div>
            </li>
            <li>
                <img src="../../assets/images/video23.png">
                <div>
                    <span>一键转发，快速推广宣传</span>
                    <p>快速生成专属海报或二维码，一键转发</p>
                </div>
            </li>
        </ul>
      </div> -->


    </div>
  </div>
</template>

<script>
export default {
  name: "shortVideo",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/shortVideoBanner.jpg") no-repeat left
      top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #fff;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #310379;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      text-align: center;
    }
  }
  .item1 {
    background-color: #f7f2fc;
    padding: 1.1rem 0.4rem 0.6rem 0.4rem;
    .title {
      font-size: 0.55rem;
      text-align: center;
      font-weight: 500;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 25%;
        text-align: center;
        padding-top: 0.9rem;
        img {
          width: 1.2rem;
        }
        span {
          font-size: 0.34rem;
          display: block;
          padding-top: 0.26rem;
        }
      }
    }
  }
  .item2{
    .title{
      font-size: .55rem;
      padding-top: 1rem;
      text-align: center;
    }
    .box1{
      background: url('../../assets/images/page64.png') left 5rem;
      
    }
    .box{
      background-size: 100% auto;
      background-repeat: no-repeat;
      padding-bottom: .5rem;
      .img{
        padding: .3rem 0;
        img{
          width: 100%;
        }
      }
    }
    
    .subTitle{
      background: url('../../assets/images/page63.jpg') no-repeat .6rem center;
      background-size: 5.28rem auto;
      height: .9rem;
      line-height: .9rem;
      padding-left: 1.5rem;
      color: #fff;
      font-size: .46rem;
      margin: .2rem 0;
      position: relative;
      z-index: 10;
    }
    ul{
      padding: 0 .4rem;
      position: relative;
      z-index: 10;
      li{
        display: flex;
        padding: .3rem 0;
        img{
          width: .9rem;
          height: .9rem;
          margin-right: .1rem;
        }
        span{
          font-size: .4rem;
          color: #000;
        }
        p{
          font-size: .34rem;
          color: #666;
          padding-top: .1rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/shortVideo.vue